import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { BulkActionsService } from './bulkActions.service';
import { Component, Inject, OnInit } from '@angular/core';
//@ts-ignore
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../dialog-confirmation/dialog.confirmation.component';
import jwt_decode from 'jwt-decode';

@Component({
  selector: 'dialog-bulkActions-component',
  templateUrl: './dialog.bulkActions.component.html',
  styleUrls: ['./dialog.bulkActions.component.css'],
  providers: [BulkActionsService]
})
export class BulkActionsDialogComponent implements OnInit {
  switcher_toggle_navigator = true;

  sort_tree_by = "folder"
  sort_by_list = [
    { value: 'folder', viewValue: 'Folder' },
    { value: 'software_name', viewValue: 'Software Name' },
    { value: 'software_version', viewValue: 'Software Version' },
    { value: 'product_id', viewValue: 'Product Id' }
  ];

  displayedColumns = ["deleteIcon", "name"];
  //items in delete tree
  received_selected_items = [];

  private user_info_obj: { name: string, role: string } = null;


  constructor(private _snackBar: MatSnackBar,
    private loggerService: LoggerService,
    public dialogRef: MatDialogRef<BulkActionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    private bulkActionsService: BulkActionsService) {

  }

  ngOnInit(): void {
    if (!this.user_info_obj) { this.user_info_obj = jwt_decode(localStorage.getItem('accessToken')); }
  }

  recieve_selected_multiple_items(items: any) {
    this.received_selected_items = items
    // let checkDb = ""
    // this.received_selected_items.forEach(item => checkDb = checkDb + item.value + ",")
  }

  openConfirmationDialogForDelete() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Delete units", message: `Confirm the deletion of ${this.received_selected_items.length} units from VMS` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkActionsService.bulkDelete(this.getSelectedIds(), this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Removed successfully from VMS and currently removing all the provisioing urls from the units this process takes time.", "Done");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  openConfirmationDialogForMonitor() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Monitor units", message: `Confirm the monitor of ${this.received_selected_items.length} units from VMS` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkActionsService.bulkMonitor(this.getSelectedIds(), this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Units were monitored successfully", "Done");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  openConfirmationDialogForUnMonitor() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "UnMonitor units", message: `Confirm the unmonitor of ${this.received_selected_items.length} units from VMS` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkActionsService.bulkUnMonitor(this.getSelectedIds(), this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Units were monitored successfully", "Done");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  openConfirmationDialogForProvision() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Provision units", message: `Confirm the provisioing of ${this.received_selected_items.length} units from VMS` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkActionsService.bulkProvision(this.getSelectedIds(), this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Your provisioing request was submitted successfully, currently changing the provisioing url on units. Check again later.", "Processing");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  openConfirmationDialogForUnProvision() {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "unProvision units", message: `Confirm the unprovisioing of ${this.received_selected_items.length} units from VMS` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkActionsService.bulkUnProvision(this.getSelectedIds(), this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Your unprovisioing request was submitted successfully, currently removing the provisioing url on units. Check again later.", "Processing");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  openConfirmationDialogForPullAllUnits(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Pull All Units Configuration Files", message: "Confirm pulling all VMS units configuration files. This process takes time so please confirm or cancel" },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.bulkActionsService.pullAllUnitsConfigurationFiles(this.user_info_obj.name).subscribe(data => {
          this.openSnackBar("Pulling all units configuration files has begun, this process may takes several minutes.", "Processing");
        }, err => {
          this.openSnackBar(err.error?.message ? err.error?.message : "Error while processing your request", "Error");
        })
      }
    });
  }

  getSelectedIds() {
    let idsToBeSent: number[] = [];
    this.received_selected_items.forEach(item => idsToBeSent.push(item.value));
    return idsToBeSent;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  onNoClick(): void {
    this.data.response = false;
    this.dialogRef.close(this.data.response);
  }
  onYesClick(): void {
    this.data.response = true;
    this.dialogRef.close(this.data.response);
  }


}
